import { Component,OnInit,Injectable,OnDestroy } from '@angular/core';
import { User } from  './user.model';
import { Auth } from './auth.model';
import { Subscription }  from 'rxjs';
import { Router} from '@angular/router';
import { AngularFireAuth} from 'angularfire2/auth'
import { Exercises} from '../traning/traning.services'
import { MatSnackBar} from '@angular/material';
import {uiService } from '../shared/ui-services';
import { Store } from '@ngrx/store';
import * as fromApp from '../app.reducer'; 
import * as UI from '../shared/ui.actions';
import * as AuthAction from './auth.actions';
@Injectable()
export class AuthService  {

constructor(private router:Router,
            private fireAuth:AngularFireAuth,
            private ExerciseService :Exercises,
            private snackBar :MatSnackBar,
            private UiServices:uiService,
            private store:Store<fromApp.State>
        ){}    

private isUser = false;
     private user:User;
    registerUser(Authdata:Auth){
        this.store.dispatch(new UI.StartLoading() );
        //this.UiServices.isLoading.next(true);
        this.fireAuth.auth.createUserWithEmailAndPassword(Authdata.email,Authdata.password)
        .then(authState =>{
                    this.store.dispatch(new UI.StopLoading());

           // this.UiServices.isLoading.next(false);
        })
        .catch((err)=>{
                 this.store.dispatch(new UI.StopLoading())

            //   this.UiServices.isLoading.next(false);
           this.UiServices.showSnackBar(err,null,4000);
        } );
        
    }

    login(Authdata:Auth){
                this.store.dispatch(new UI.StartLoading());

        //this.UiServices.isLoading.next(true);
        this.fireAuth.auth.signInWithEmailAndPassword(Authdata.email,Authdata.password)
        .then((authState)=>{
        this.store.dispatch(new UI.StopLoading())

            //this.UiServices.isLoading.next(false);
        })
        .catch((error)=> {
           this.store.dispatch(new UI.StopLoading())

   
            //         this.UiServices.isLoading.next(false);
            this.UiServices.showSnackBar(error,null,4000);
        });

    }

    logout(){

        this.ExerciseService.cancelSubscription();
        this.isUser =false;

        this.fireAuth.auth.signOut();
            }

    initAuthentication(path){
        this.fireAuth.authState.subscribe(user =>{
            if(user )
                {       
                            this.store.dispatch(new AuthAction.isAuthenticate());
                            this.router.navigate(['/traning']);

                }
                else if(path ){
                            console.log('ins else');
                            this.ExerciseService.cancelSubscription();
                            this.store.dispatch(new AuthAction.isUnAuthenticate());

                            this.router.navigate(['/login']);
                    
                }
            else {
                                            this.ExerciseService.cancelSubscription();
                            this.store.dispatch(new AuthAction.isUnAuthenticate());

                            this.router.navigate(['/']);
                    
            }
        });
    }    
}